import React from "react";
import Modal from "../Modal";
import Button from "../Button";
import styled from "styled-components";
import { Colors, Text } from "../../config";
import { useNavigate } from "react-router-dom";
import { useGuestContext } from "../../contexts/GuestContext";
import { usePaxContext } from "../../contexts/PassengerContext";
import { useBookingContext } from "../../contexts/BookingContext";
import { BOOKING_INIT } from "../../config/Constants";

const CancelRequestModal = ({ setClose }) => {
  const { setBooking } = useBookingContext();
  const { setGuests } = useGuestContext();
  const { setPax } = usePaxContext();
  const navigate = useNavigate();
  const handleYes = () => {
    setGuests([]);
    setPax([]);
    let resetBooking = JSON.parse(JSON.stringify(BOOKING_INIT));
    setBooking(resetBooking);
    navigate("/user/dashboard");
  };
  return (
    <Modal setClose={setClose}>
      <CancelContainer>
        <HeaderSubheader>
          <CancelHeader>{Text.cancelRequest}</CancelHeader>
          <CancelSubheader>
            {Text.areYouSureYouWantToCancelThisRequest}
          </CancelSubheader>
        </HeaderSubheader>
        <ButtonWrapper>
          <Button
            label="No"
            bgColor={Colors.white}
            fontColor={Colors.black}
            outlineColor={Colors.black}
            topBottomPadding="0.75rem"
            onClick={setClose}
          />
          <Button
            label="Yes"
            bgColor={Colors.pomegranate}
            topBottomPadding="0.75rem"
            onClick={handleYes}
          />
        </ButtonWrapper>
      </CancelContainer>
    </Modal>
  );
};

export default CancelRequestModal;

const CancelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.75rem;
  padding: 2.625rem 1.75rem 2.25rem;
`;
const CancelHeader = styled.div`
  font-weight: 700;
  font-size: 1.375rem;
  color: ${Colors.brandOne};
`;
const CancelSubheader = styled.div`
  font-weight: 400;
  font-size: 1rem;
  color: ${Colors.mineShaft};
  text-align: center;
  width: 75%;
  @media only screen and (max-width: 478px) {
    width: 100%;
  }
`;
const ButtonWrapper = styled.div`
  width: 20.375rem;
  display: flex;
  gap: 1rem;
  @media only screen and (max-width: 478px) {
    flex-direction: column-reverse;
    width: 14rem;
  }
`;
const HeaderSubheader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;
